import PropTypes from "prop-types";
import React from "react";
import { Field } from "redux-form";
import { FormattedMessage } from "react-intl";
import messages from "components/messagesDescription";

class Range extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      selectedValue: this.getInitialValue(),
      submittedValue: this.setInitialSubmitValue(),
      options: this.props.options,
    };
  }

  setSelectedValue = e => {
    const submittedValue = this.state.options[e.target.value - 1]
      .questionOptionId;
    this.setState({
      selectedValue: e.target.value,
      submittedValue: submittedValue,
    });

    // Submit the changed value to Redux store
    this.props.input.onChange(submittedValue);
  };

  getInitialValue() {
    return (
      this.props.options.findIndex(
        option => option.questionOptionId === this.props.input.value
      ) + 1 || (this.props.max - this.props.min) / 2 + this.props.min
    );
  }

  setInitialSubmitValue() {
    return this.props.input.value || this.state.submittedValue;
  }

  render() {
    const { min, max, step, meta, input, label } = this.props;
    const { error, submitFailed } = meta;
    const value = this.state.selectedValue;
    const submittedValue = this.state.submittedValue;

    return (
      <p>
        <label
          htmlFor={`${input.name}_range`}
          className="cxa-c-form__block-label"
        >
          <FormattedMessage id={label} defaultMessage={label} />
        </label>
        <input
          type="range"
          id={`${input.name}_range`}
          name={`${input.name}_range`}
          value={value}
          min={min}
          max={max}
          step={step}
          onChange={this.setSelectedValue}
        />{" "}
        <output className="apl-form__range" htmlFor={`${input.name}_range`}>
          {value}
        </output>
        <input
          type="hidden"
          id={input.name}
          name={input.name}
          value={submittedValue}
        />
        {submitFailed &&
          <span className="field__error">
            {error}
          </span>}
      </p>
    );
  }
}

Range.propTypes = {
  label: PropTypes.string,
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  selected: PropTypes.number,
  defaultValue: PropTypes.number,
  options: PropTypes.array,
  meta: PropTypes.object,
  input: PropTypes.object,
};

const RangeField = props => <Field component={Range} {...props} />;

const TableGroupingLayout = ({ subsection, selectedLanguage }) => {
  return (
    <section>
      <h2>
        <FormattedMessage
          id={subsection.subsectionName}
          defaultMessage={subsection.subsectionName}
        />
      </h2>

      <p>
        1 = <FormattedMessage {...messages.stronglyDisagreeDescription} />
      </p>
      <p>
        5 = <FormattedMessage {...messages.disagreeDescription} />
      </p>
      <p>
        9 = <FormattedMessage {...messages.stronglyAgreeDescription} />
      </p>

      {subsection.questions &&
        subsection.questions.map(q => {
          return (
            <RangeField
              key={q.questionId}
              name={`question_${q.tag}`}
              min={1}
              max={q.questionOptions.length}
              step={1}
              options={q.questionOptions}
              label={q.questionText}
            />
          );
        })}
    </section>
  );
};

TableGroupingLayout.propTypes = {
  subsection: PropTypes.object,
  selectedLanguage: PropTypes.object,
};

export default TableGroupingLayout;



// WEBPACK FOOTER //
// ./components/wellness/lifestyleAgeing/questionnaire/layouts/table-grouping.jsx